export default __webpack_public_path__ + "static/media/Gauge2.5c70d363.jpg";